import type { ReactNode } from 'react';

export default function PageHeader({ eyebrow, title, subtitle, action }: { eyebrow?: string; title: string; subtitle?: string; action?: ReactNode }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div>
        {eyebrow && <div className="text-xs uppercase tracking-widest text-dim">{eyebrow}</div>}
        <h1 className="text-2xl lg:text-3xl font-semibold leading-tight mt-0.5">{title}</h1>
        {subtitle && <p className="text-dim text-sm mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
